export default {
  tab: {
    selectJob: 'Załaduj wybór',
  },
};
